module.exports = __webpack_public_path__ + "img/3.47f71af7.png";